import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import customerReducer from "./customerSlice";
import userReducer from "./userSlice";
import tiktokReducer from "./dataTiktok";
import facebookReducer from "./dataFacebook";
import {
    persistStore,
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const persistConfig = {
    key: 'root',
    version: 1,
    storage,
}
const appReducer = combineReducers({
    auth: authReducer,
    customer: customerReducer,
    user: userReducer,
    tiktok: tiktokReducer,
    facebook: facebookReducer,
});

// 🧠 Thêm logic để reset state khi nhận action RESET_ALL
const rootReducer = (state, action) => {
    if (action.type === "RESET_ALL") {
        storage.removeItem("persist:root"); // Xoá cache trong localStorage
        state = undefined; // Reset toàn bộ Redux state
    }
    return appReducer(state, action);
};
const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }),
})

export let persistor = persistStore(store)
